import {Formik} from 'formik';

import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    TestDefinitionFormValues,
    TestDefinitionRecordFormProps,
} from '../types';
import {stage} from '../../../config/stage';

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: TestDefinitionRecordFormProps) => {

    // RETURN the promise (FNP-932). Dropping it here defeats FNP-925 one layer
    // down: Formik never sees a pending promise, so the submission stays pending
    // forever and the Save button latches disabled — a rejected save can then
    // never be retried without a reload.
    const onSubmit = (values: TestDefinitionFormValues) => {
        return handleSubmit(values);
    };

    const editing = Boolean(record?.id);

    return (
        <Formik
            initialValues={record}
            validationSchema={RecordSchema}
            enableReinitialize
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    handleCancel={handleCancel}
                    debug={false && stage === 'ide'}
                    {...rest}
                >
                    <FormComponent editing={editing}/>
                </FormWithButtons>)}
        </Formik>
    );
};
